import { Box, Typography } from "@mui/material";
import { styles } from "./stylesComingSoon";
import badgeComingSoonIcon from "@/assets/image/comingSoon/badgeComingSoon.svg";
import badgePremiumIcon from "@/assets/image/comingSoon/badgePremium.svg";
import cardBgPitch from "@/assets/image/comingSoon/cardBgPitch.svg";
import cardBgStats from "@/assets/image/comingSoon/cardBgStats.svg";
import awardStar from "@/assets/image/comingSoon/awardStar.svg";
import awardCup from "@/assets/image/comingSoon/awardCup.svg";
import awardArrow from "@/assets/image/comingSoon/awardArrow.svg";
import awardSend from "@/assets/image/comingSoon/awardSend.svg";
import awardSync from "@/assets/image/comingSoon/awardSync.svg";
import awardHeart from "@/assets/image/comingSoon/awardHeart.svg";
import awardCoins from "@/assets/image/comingSoon/awardCoins.svg";
import awardBars from "@/assets/image/comingSoon/awardBars.svg";
import awardCupCircle from "@/assets/image/comingSoon/awardCupCircle.svg";

const awards = [
  {
    icon: awardStar,
    title: "Top Post of the Week",
    desc: "Highest earnings on a single post. The Friday headline.",
    highlighted: true,
  },
  {
    icon: awardCup,
    title: "Top Article",
    desc: "Best long-form analysis. Rewards depth, not hot takes.",
    highlighted: false,
  },
  {
    icon: awardArrow,
    title: "Rising Star",
    desc: "Top earner among accounts under 90 days old.",
    highlighted: false,
  },
  {
    icon: awardSend,
    title: "Top Ticker Trader",
    desc: "Best contributor to a trending stock conversation.",
    highlighted: false,
  },
  {
    icon: awardSync,
    title: "Comeback of the Week",
    desc: "Biggest week-over-week earnings jump.",
    highlighted: false,
  },
  {
    icon: awardHeart,
    title: "People's Choice",
    desc: "Most likes from unique users. Broad appeal wins.",
    highlighted: false,
  },
  {
    icon: awardCoins,
    title: "Macro Mind",
    desc: "Best Economics post. Monthly award.",
    highlighted: false,
  },
  {
    icon: awardBars,
    title: "Chart of the Month",
    desc: "Best Technical post. Community-voted.",
    highlighted: false,
  },
  {
    icon: awardCupCircle,
    title: "The Alpha",
    desc: "Annual grand prize. Trader of the Year.",
    highlighted: true,
  },
];

const steps = [
  {
    number: "1",
    title: "Go Premium",
    desc: "$5/month unlocks award eligibility — plus every Premium perk.",
  },
  {
    number: "2",
    title: "Make the cut",
    desc: "Top 10-25 Premium members in each category enter the weekly pool.",
  },
  {
    number: "3",
    title: "Friday draw",
    desc: "Winners drawn live, provably random, every Friday at market close.",
  },
  {
    number: "4",
    title: "Get paid",
    desc: "Cash prizes paid instantly to your Wethemrkt wallet. No catches.",
  },
];

const stats = [
  { value: "15%", line1: "Of platform revenue", line2: "Reserved for prizes", divided: false },
  { value: "$5", line1: "Per month to unlock", line2: "Eligibility", divided: true },
  { value: "9+", line1: "Awards every", line2: "Single week", divided: false },
];

const ComingSoon = () => {
  return (
    <Box sx={styles.page}>
      <Box sx={styles.header}>
        <Box sx={styles.badge("comingSoon")}>
          <Box component="img" src={badgeComingSoonIcon} alt="" sx={styles.badgeIcon} />
          <Typography component="span" sx={styles.badgeText}>
            Coming Soon
          </Typography>
        </Box>
        <Box sx={styles.badge("premium")}>
          <Box component="img" src={badgePremiumIcon} alt="" sx={styles.badgeIcon} />
          <Typography component="span" sx={styles.badgeText}>
            Premium Exclusive
          </Typography>
        </Box>
      </Box>

      <Box sx={styles.heroSection}>
        <Box sx={styles.heroText}>
          <Typography sx={styles.heroTitle}>
            Alpha Awards.
            <br />
            Only for the few.
          </Typography>
          <Typography sx={styles.heroSubtitle}>
            A portion of Wethemrkt's platform revenue goes straight back to the traders making this
            place worth being on. Quality posts. Rising voices. Best calls. Real cash prizes — drawn
            live, every Friday. Reserved exclusively for Premium members.
          </Typography>
        </Box>

        <Box sx={styles.pitchBanner}>
          <Box component="img" src={cardBgPitch} alt="" sx={styles.bannerBg} />
          <Box sx={styles.pitchContent}>
            <Typography sx={styles.bannerLabel}>The Pitch</Typography>
            <Typography sx={styles.pitchHeading}>
              Every other platform takes a cut.
              <br />
              <Box component="span" sx={styles.pitchHeadingAccent}>
                We give it back — to Premium.
              </Box>
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={styles.section}>
        <Box sx={styles.sectionHead}>
          <Box sx={styles.sectionLabelRow}>
            <Box sx={styles.sectionLabelLine} />
            <Typography sx={styles.sectionLabelText}>THE AWARDS</Typography>
          </Box>
          <Typography sx={styles.sectionTitle}>Nine ways to win, every single week.</Typography>
        </Box>

        <Box sx={styles.awardsGrid}>
          {awards.map((award) => (
            <Box key={award.title} sx={styles.awardCard(award.highlighted)}>
              <Box sx={styles.awardIconBox(award.highlighted)}>
                <Box component="img" src={award.icon} alt="" sx={styles.awardIcon} />
              </Box>
              <Box sx={styles.awardTextWrap}>
                <Typography sx={styles.awardTitle(award.highlighted)}>{award.title}</Typography>
                <Typography sx={styles.awardDesc(award.highlighted)}>{award.desc}</Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

      <Box sx={styles.section}>
        <Box sx={styles.sectionHead}>
          <Box sx={styles.sectionLabelRow}>
            <Box sx={styles.sectionLabelLine} />
            <Typography sx={styles.sectionLabelText}>HOW IT WORKS</Typography>
          </Box>
          <Typography sx={styles.sectionTitle}>
            Premium gets you eligible. Merit gets you in the room. Randomness picks the winner.
          </Typography>
        </Box>

        <Box sx={styles.stepsRow}>
          {steps.map((step, index) => (
            <Box key={step.number} sx={styles.stepCard}>
              <Typography sx={styles.stepNumber(index === 0)}>{step.number}</Typography>
              <Box sx={styles.stepInner}>
                <Typography sx={styles.stepTitle}>{step.title}</Typography>
                <Typography sx={styles.stepDesc}>{step.desc}</Typography>
              </Box>
            </Box>
          ))}
        </Box>

        <Box sx={styles.statsWrap}>
          <Box sx={styles.statsBanner}>
            <Box component="img" src={cardBgStats} alt="" sx={styles.statsBg} />
            {stats.map((stat) => (
              <Box key={stat.value} sx={styles.statCol(stat.divided)}>
                <Typography sx={styles.statValue}>{stat.value}</Typography>
                <Typography sx={styles.statLabel}>
                  {stat.line1}
                  <br />
                  {stat.line2}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ComingSoon;
